module.exports = __webpack_public_path__ + "static/media/dashboard.f2a0cdea.svg";